import Story1Image from "../assets/images/png/testimony/ferdinand.webp";
import Story2Image from "../assets/images/png/testimony/hambolu.webp";
import Story3Image from "../assets/images/png/testimony/charles.webp";
import Story4Image from "../assets/images/png/testimony/eniola.webp";

export const generalTestimonies = [
  {
    id: 2,
    linkedIn: "https://www.linkedin.com/in/mayowa-hambolu/",
    image: Story2Image,
    firstname: "Mayowa",
    lastname: "Hambolu",
    company: "Data Fellow",
    testimony: `
        I was looking for something a little more than a training, a school I could count on for 
        my continuous skill and professional development. Utiva kept coming up so I jumped in. I went through the Data 
        Accelerator program and then the ‘Big Data with Python’ program. I am now a Data Scientist and Consultant.
        `,
  },
  {
    id: 3,
    linkedIn: "https://www.linkedin.com/in/thacharlescharles/",
    image: Story3Image,
    firstname: "Charles",
    lastname: "Charles",
    company: "Product Fellow ",
    testimony: `
        I was a young SAP Analytics Consultant seeking analytics knowledge beyond the SAP space when I joined Utiva. And then, the calibre 
        of faculty at Utiva are top experts across different industries and are well grounded in their fields.
        Also, I got a full scholarship to the Data School, and this gave me a first-hand experience of class.
        `,
  },
  {
    id: 4,
    linkedIn: "https://www.linkedin.com/in/eniola-orireyemi-872357117/",
    image: Story4Image,
    firstname: "Eniola",
    lastname: "Orireyemi",
    company: "Product Marketing Manager, truQ",
    testimony: `
    My training at Utiva was really great. I took the training in 
    2020. And to a very large extent, it’s still one of the most solid 
    training experiences I’ve had. I still recommend Utiva till date. 
    This is a solid curriculum and delivery approach. 
        `,
  },
  {
    id: 1,
    linkedIn:
      "https://www.linkedin.com/in/chizuruoke-ferdinard-iheme-89b991aa/",
    image: Story1Image,
    firstname: "Ferdinand ",
    lastname: "Iheme",
    company: "Data Fellow",
    testimony: `
        I did research and asked around about a reputable tech training institute, 
        so a friend gave a high recommendation about Utiva. 
        I reached out to them and made arrangements to go to Lagos because I 
        reside in Abuja and the classes were running offline then. 
        Yes Utiva gave me all I wanted. I started my journey into AI through the Utiva learning program.
        `,
  },
];
